import { DataTypes } from "../../../data/DataManager";
import { EMPTY_VALUE, EMPTY_VALUES, FieldSchema, FieldValue, FieldValues, isEmpty } from "../../../Schema";
import { SubEquipmentItem } from "../../cluster";

/**
 * Cluster variant of `softwareVersion`. It is not edited directly in the cluster
 * form: the value mirrors the software version of the sub-equipment flagged as the
 * leading software version (`leadingSoftwareVersionId`), and the input is always
 * disabled. When no leading sub-equipment is selected the value is empty.
 *
 * The value recomputes automatically whenever `subEquipments` or
 * `leadingSoftwareVersionId` change (declared as `assignedValue` dependencies).
 */
export const softwareVersion: FieldSchema = {
  name: "softwareVersion",
  dataTransform: {
    fromGraphql: {
      getter: ({ softwareVersion }) =>
        softwareVersion === "null" || EMPTY_VALUES.includes(softwareVersion) ? EMPTY_VALUE : softwareVersion,
    },
  },
  data: {
    type: DataTypes.STRING,
    active: true,
    assignedValue: {
      getter: ({ subEquipments, leadingSoftwareVersionId }: FieldValues) => {
        if (!leadingSoftwareVersionId || !Array.isArray(subEquipments)) {
          return EMPTY_VALUE;
        }
        const leading = (subEquipments as SubEquipmentItem[]).find(
          (item) => item?.id === leadingSoftwareVersionId
        );
        // Sub-equipment row keys are snake_cased (see keysToSnakeCase); tolerate camelCase too.
        const version = leading?.software_version ?? leading?.softwareVersion;
        return isEmpty(version) ? EMPTY_VALUE : (version as FieldValue);
      },
      fields: ["subEquipments", "leadingSoftwareVersionId"],
    },
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Software version",
    disabled: true,
  },
};
